import { useState, useEffect } from "react";

import axios from 'axios';
import { useCookies } from 'react-cookie';
import { useToast } from "../lib/useToast"
import { Toaster } from "../components/Toaster"

import {
    Card,
    TabList,
    Tab,
  } from "@tremor/react";

import './FinancePage.css';
import SidebarComponent from '../components/SidebarComponent';
import TitleComponent from "../components/TitleComponent";

import BillingCustumersComponent from "../components/financeComponents/BillingCustomers";
import DriverPaymentComponent from "../components/financeComponents/DriverPayment";
import PricesTableComponent from "../components/financeComponents/PricesTable";

export default function FinancePage() {
    const [showCard, setShowCard] = useState("0");

    return (
        <main className="Page">
        <SidebarComponent />
        <div className="Content">
            <TitleComponent />
            <Toaster />
            <div className="OpsViews">
                <TabList
                    defaultValue="0"
                    onValueChange={(value) => setShowCard(value)}
                >
                    <Tab value="0" text="Cobrança Clientes" className={showCard === "0" ? 'SelectedTab' : 'OtherTab'}/>
                    <Tab value="1" text="Pagamento Motoristas" className={showCard === "1" ? 'SelectedTab' : 'OtherTab'}/>
                    <Tab value="2" text="Tabelas de Preços" className={showCard === "2" ? 'SelectedTab' : 'OtherTab'}/>
                </TabList>

                <Card className="mt-6">
                    {showCard === "0" ? (
                    <BillingCustumersComponent />
                    ) : ("")}
                    {showCard === "1" ? (
                    <DriverPaymentComponent />
                    ) : ("")}
                    {showCard === "2" ? (
                    <PricesTableComponent />
                    ) : ("")}                    
                </Card>
            </div>
        </div>
        </main>
    )
}